import { GeneralSetting } from '@apis/index'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

export const useFaqData = (category: string) => {
  const { data } = useSelector((state: any) => state.faqs)

  useEffect(() => {
    if (!data?.length) {
      GeneralSetting.getByGroup({ id: 'faqs', state: 'faqs' })
        .then((res) => console.log('faqs:', res))
        .catch(() => {})
    }
  }, [])

  const filteredFaqs = useMemo(() => {
    if (!Array.isArray(data)) return []
    return data
      .map((item) => {
        try {
          return JSON.parse(item.value)
        } catch (error) {
          console.error('Invalid FAQ JSON:', item.value)
          return null
        }
      })
      .filter(
        (item) =>
          item &&
          item.category?.trim().toLowerCase() === category.trim().toLowerCase(),
      )
  }, [data, category])

  return filteredFaqs
}
